module.exports = __webpack_public_path__ + "img/img2.1e780a24.png";